module.exports = __webpack_public_path__ + "static/media/3.264bb222.png";